module.exports = __webpack_public_path__ + "static/media/refresh-ccw.f9c74577.svg";